/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Stav úlohy importu/aktualizace běžící na pozadí
 * @export
 * @enum {string}
 */

export const JsonImportState = {
    /**
    * Probíhá
    */
    RUNNING: 'RUNNING',
    /**
    * Dokončeno
    */
    DONE: 'DONE',
    /**
    * Chyba
    */
    ERROR: 'ERROR'
} as const;

export type JsonImportState = typeof JsonImportState[keyof typeof JsonImportState];



